import React, { useEffect, useState } from "react";
import ShowToast from "components/ShowToast";

import "./Walletsettlement.css";
import { useSession } from "hooks/useSession";
import AddBillpayBankAccountModal from "./components/Addbillpaybankaccountmodal";
import MakeBillpaySendMoneyModal from "./components/Makebillpaysendmoneymodal";
import { fetchWrapper } from "utils/apiFetch";
import PayoutReceiptModal from "Settings/Reports/PayoutReceipt";

// Cyrus / billpay equivalent of Cashout.js. Same screen shape, different
// backend wiring:
//   - list  -> POST billpay_beneficiary_list   {}                (user comes from auth token)
//   - add   -> POST billpay_add_beneficiary    { beneficiary_bank_account_number,
//                                                 beneficiary_bank_ifsc_code,
//                                                 beneficiary_name, beneficiary_phone,
//                                                 beneficiary_aadhar, pan_number,
//                                                 beneficiary_address, bene_type,
//                                                 latlong, Aadhar_checked_and_verified,
//                                                 consent }
//   - pay   -> POST billpay_send_money         { transection_mode, amount, holder_name,
//                                                 mobile, comments, beneficiaryid, remark }
//   - status-> POST billpay_check_status       { orderId }
const Cashout2 = () => {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showPayModal, setShowPayModal] = useState(false);
  const [showReceipt, setShowReceipt] = useState(false);
  const [receiptId, setReceiptId] = useState(null);

  const { userid } = useSession();

  useEffect(() => {
    fetchBeneficiaryList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchBeneficiaryList = async () => {
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("user_id", userid);

      const res = await fetchWrapper("https://pro.mokshiq.in/billpay_beneficiary_list", {
        method: "POST",
        body: formData,
      });

      // backend returns { data: [{ cyrusid, account, IFSC_Code, name, Bank_Name }], status }
      setList(res?.data || []);
    } catch (e) {
      ShowToast("Failed to load billpay beneficiaries", "danger");
    } finally {
      setLoading(false);
    }
  };

  const handleView = (row) => {
    setSelectedRow(row);
    setShowReceipt(true);
  };

  const handleCloseReceipt = () => {
    setShowReceipt(false);
    setSelectedRow(null);
  };

  return (
    <main>
      <div className="container-fluid ui-section">
        <div className="row m-1">
          <div className="col-10">
            <h4 className="main-title">Bill Pay Settlement</h4>
            <ul className="app-line-breadcrumbs mb-3">
              <li>
                <a className="f-s-14 f-w-500" href="#">
                  <span>
                    <i className="ph-duotone ph-briefcase-metal f-s-16"></i>{" "}
                    Services
                  </span>
                </a>
              </li>
              <li className="active">
                <a className="f-s-14 f-w-500" href="#">
                  Bill Pay Settlement
                </a>
              </li>
            </ul>
          </div>
          <div className="col-2 d-flex gap-2 justify-content-end">
            <button className="add-btn" onClick={() => setShowAddModal(true)}>
              Add Account
            </button>
          </div>
        </div>

        <div className="wallet-page">
          {loading ? (
            <div className="loader">Loading...</div>
          ) : list.length === 0 ? (
            <div className="empty-state">No billpay beneficiaries added</div>
          ) : (
            <div className="wallet-grid">
              {list.map((item, index) => (
                <div className="wallet-card" key={`${item.cyrusid || item.account}-${index}`}>
                  <div className="card-header">
                    <h5>{item.Bank_Name}</h5>
                  </div>

                  <div className="card-body">
                    <div className="info-row">
                      <span>Account Holder</span>
                      <b>{item.name}</b>
                    </div>
                    <div className="info-row">
                      <span>Account No</span>
                      <b>{item.account}</b>
                    </div>
                    <div className="info-row">
                      <span>IFSC</span>
                      <b>{item.IFSC_Code}</b>
                    </div>
                    <div className="info-row">
                      <span>Beneficiary ID</span>
                      <b>{item.cyrusid}</b>
                    </div>
                  </div>

                  <div className="card-footer">
                    <button
                      className="btn primary"
                      onClick={() => {
                        setSelectedRow(item);
                        setShowPayModal(true);
                      }}
                    >
                      Settle Now
                    </button>
                    <button className="btn secondary" onClick={() => handleView(item)}>
                      View
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* Add Account Modal */}
          <AddBillpayBankAccountModal
            show={showAddModal}
            onClose={() => setShowAddModal(false)}
            onSuccess={fetchBeneficiaryList}
          />

          {/* Make Payment Modal */}
          {selectedRow && showPayModal && (
            <MakeBillpaySendMoneyModal
              key={selectedRow.cyrusid || selectedRow.account}
              show={showPayModal}
              onClose={() => {
                setShowPayModal(false);
                setSelectedRow(null);
              }}
              userData={selectedRow}
              onSuccess={(referenceNum) => {
                setShowPayModal(false);
                setSelectedRow(null);
                fetchBeneficiaryList();

                // MakeBillpaySendMoneyModal already confirmed status === true
                // and calls onSuccess(res.reference_num) — just the string.
                if (referenceNum) {
                  setReceiptId(referenceNum);
                  setShowReceipt(true);
                } else {
                  ShowToast("Payment succeeded but no reference number was returned", "warning");
                }
              }}
            />
          )}
        </div>
        <PayoutReceiptModal
          isOpen={showReceipt}
          onClose={handleCloseReceipt}
          payoutId={receiptId} // or receiptData={selectedRow} if the row already has full data
        />
      </div>
    </main>
  );
};

export default Cashout2;